import React, { useEffect } from 'react';
import ChangeIndicator from '@atlaskit/icon/glyph/hipchat/media-attachment-count';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { SidebarTranslations } from '@atlassian/jira-language-settings/src/ui/sidebar-translations/main.tsx';
import { TitleHeader } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/title-header/main.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { NestingMenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/ui/nesting-menu-item/main.tsx';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useEnabledLanguages } from '@atlassian/jira-servicedesk-languages/src/services/languages/index.tsx';
import { useTranslationSummaries } from '@atlassian/jira-servicedesk-languages/src/services/translation-summaries/index.tsx';
import messages from '../messages.tsx';

export const Language = () => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();
	const [enabledLanguages, { fetchLanguages }] = useEnabledLanguages();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ data: translations }] = useTranslationSummaries();

	useEffect(() => {
		if (project) {
			const analyticsEvent = createAnalyticsEvent({});
			fetchLanguages(project.id, analyticsEvent);
		}
	}, [createAnalyticsEvent, fetchLanguages, project]);

	if (project == null) {
		return <SkeletonItem />;
	}

	const baseSettingsUrl = `/jira/servicedesk/projects/${project.key}/settings`;

	const BackMenuItem = {
		href: `${baseSettingsUrl}/language`,
		title: formatMessage(messages.itemBack),
	};

	return (
		<>
			<TitleHeader>{formatMessage(messages.languageSupport)}</TitleHeader>

			<Section>
				{enabledLanguages
					?.filter((language) => language.state !== 'unused')
					.map((language) => {
						const summary = translations?.languageTranslationSummaries?.find(
							(v) => v.key === language.key,
						);
						return (
							<NestingMenuItem
								analytics={{ itemId: language.key }}
								iconAfter={
									summary?.flaggedSections ? (
										// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
										<ChangeIndicator primaryColor={token('color.icon.warning')} label="" />
									) : null
								}
								id={language.key}
								key={language.key}
								title={language.label}
								href={`${baseSettingsUrl}/language/${language.key}`}
								overrides={{ BackMenuItem }}
							>
								<SidebarTranslations />
							</NestingMenuItem>
						);
					})}
			</Section>
		</>
	);
};
